import { useState, useEffect } from 'react';
import MessageStore from '../stores/messageStore';
import { openPopup } from '../thirdParty/NT3rdFun';
import Config from '../utils/config';

export default function usePrivateMessage() {
    const [ privateMessageCount, setPrivateMessageCount ] = useState(0);
    const [ privateMessage, setPrivateMessage ] = useState('');

    function openPrivateMessage() {
        openPopup(
            { Type: '7', Key: 'private' },
            Config.appConfig.SiteTitle,
            { wx: 1050, wy: 800 }
        );
        MessageStore.readPrivateMessage();
    }
        
    // subscribe private message
    useEffect(() => {
        function setPrivateInfo() {
            const { privateMessage, privateMessageCount } = MessageStore.getPrivateInfo();
            setPrivateMessage(privateMessage);
            setPrivateMessageCount(privateMessageCount);
        }

        MessageStore.subscribePrivateInfo(setPrivateInfo);
        return () => MessageStore.unSubscribePrivateInfo(setPrivateInfo);
    }, [setPrivateMessage, setPrivateMessageCount]);

    return {
        privateMessageCount,
        privateMessage,
        openPrivateMessage
    };
}